import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Components/Common/Layout";
import Login from "./Doctor/Login";
import PageLoader from "./Components/Common/PageLoader";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";

const DoctorDashboard = lazy(() => import("./Doctor/DoctorDashboard"));
const DoctorRegistration = lazy(() => import("./Doctor/DoctorRegistration"));
const PatientDashboard = lazy(() => import("./Patient/PatientDashboard"));
const AddCase = lazy(() => import("./Pages/AddCase"));
const AdminDashboard = lazy(() => import("./Admin/AdminDashboard"));
const ViewCases = lazy(() => import("./Pages/ViewCases"));
const AddFamily = lazy(() => import("./Patient/AddFamily"));
const BpMonitoring = lazy(() => import("./Patient/BpMonitoring"));
const DoctorList = lazy(() => import("./Doctor/DoctorList"));
const PatientProfile = lazy(() => import("./Patient/PatientProfile"));
const ForgotPassword = lazy(() => import("./Doctor/ForgotPassword"));
const DoctorProfile = lazy(() => import("./Doctor/DoctorProfile"));
const MemberLogin = lazy(() => import("./Patient/MemberLogin"));
const AddBpRecords = lazy(() => import("./Patient/AddBpRecords"));
const Doctors = lazy(() => import("./Doctor/Doctors"));
const FamilyMembers = lazy(() => import("./Patient/FamilyMembers"));
const Reports = lazy(() => import("./Pages/Reports"));
const BpReport = lazy(() => import("./Pages/BpReport"));
const AllCases = lazy(() => import("./Reports/AllCases"));
const Drafts = lazy(() => import("./Patient/Drafts"));
const Contact = lazy(() => import("./Pages/Contact"));
const Instructions = lazy(() => import("./Pages/Instructions"));
const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy"));

// axios.defaults.baseURL = "http://localhost:3003/api/";

axios.defaults.baseURL = "https://api.hypertensionfoundationofindia.com";

toast.configure();

function App(props) {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/member-login" element={<MemberLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/doctor-registration" element={<DoctorRegistration />} />

          <Route path="/" element={<Layout />}>
            <Route path="/doctor-dashboard" element={<DoctorDashboard />} />
            <Route path="/patient-dashboard" element={<PatientDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/add-case" element={<AddCase />} />
            <Route path="/edit-case/:id" element={<AddCase />} />
            <Route path="/view-cases" element={<ViewCases />} />
            <Route path="/draft-cases" element={<Drafts />} />
            <Route path="/add-family-members/:id" element={<AddFamily />} />
            <Route path="/bp-monitoring" element={<BpMonitoring />} />
            <Route path="/bp-reports" element={<BpReport />} />
            <Route path="/view-doctors" element={<Doctors />} />
            <Route path="/patient-profile/:id" element={<PatientProfile />} />
            <Route path="/doctor-profile/:id" element={<DoctorProfile />} />
            <Route path="/add-bp-records/:id" element={<AddBpRecords />} />
            <Route path="/family-members" element={<FamilyMembers />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/instructions" element={<Instructions />} />
            <Route path="/all-cases" element={<AllCases />} />
          </Route>
          <Route path="*" element={<Login />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
